import * as THREE from "three";
import {
  createGradientCircle,
  handleCircleSize,
} from "../utils/threeJsUtils";
import { initialLineWidth } from "../Components/Settings/defaultSettings";
import { useRef } from "react";
import {
  setupModelTransform,
  processModelNodes,
  createBuildingCircleAndLabel,
} from "../utils/modelBuilderUtils";

/**
 * Custom hook for managing model references and building/project model creation
 */
export const useModelsRefs = ({
  appTypeModelsRef,
  scene,
  spritesNodesRef,
  areaNodesRef,
  loadedModels,
  buildings,
  projectModels,
  projectDefaultView,
  gradientColors,
  vacantColor,
  occupiedColor,
  occupiedHoveredColor,
  floorMat,
  setModelReady,
  colors
}) => {

    const modelsRef = useRef({});
      const floorsNodes = useRef([]);
const floorLines = useRef([]);
const floorLabels = useRef([]);
  const buildBuildingGroups = () => {
    // console.log("buildBuildingGroups", colors);

    buildings.forEach((building, index) => {
      // Skip if building already exists
      if (modelsRef.current[building.id]) return; 
      
      // Create a group to hold floor lines and labels
      const floorLinesGroup = new THREE.Group();

      if (loadedModels.buildingsModels[building.id]) {
        const model = loadedModels.buildingsModels[building.id];
        model.castShadow = true;
        model.receiveShadow = true;

        setupModelTransform(model, floorLinesGroup, building);

        // Process all nodes in the model
        processModelNodes(
          model,
          building,
          projectDefaultView,
          scene,
          floorLinesGroup,
          {
            floorsNodes,
            floorLines,
            floorLabels,
            appTypeModelsRef,
            areaNodesRef,
            spritesNodesRef,
          },
          {
            vacantColor,
            occupiedColor,
            occupiedHoveredColor,
          }
        );
  
        // Add model to scene
        model.visible = true;
        scene.current.add(model);

        // Create building circle and label
        const { circle, buildingLabel } = createBuildingCircleAndLabel(
          model,
          building,
          scene,
          gradientColors
        );

        // Store references
        modelsRef.current[building.id] = model;
        modelsRef.current[building.id].circle = circle;
        modelsRef.current[building.id].label = buildingLabel;
        modelsRef.current[building.id].floorsGroup = floorLinesGroup;

      } else {
        console.warn(
          "projectModels not found for building: " +
            building.name +
            " id: " +
            building.id
        );
      }
    });
    // console.log("setModelReady");
    setModelReady(true);
  };

  /**
   * Build project models (non-building models)
   */
  const buildProjectModels = () => {
    // console.log("buildProjectModels", { loadedModels, projectModels });


    projectModels.forEach((pm, index) => {
      const model = loadedModels.projectModels[pm.id];
      const modelPosition =
        pm.default_view && pm.default_view.position
          ? pm.default_view.position
          : { x: 0, y: 0, z: 0 };
      const modelScale =
        pm.default_view && pm.default_view.scale
          ? pm.default_view.scale
          : { x: 1, y: 1, z: 1 };
      const modelRotation =
        pm.default_view && pm.default_view.rotation
          ? pm.default_view.rotation
          : { _x: 0, _y: 0, _z: 0 };

      model.scale.set(modelScale.x, modelScale.y, modelScale.z);
      model.rotation.set(modelRotation._x, modelRotation._y, modelRotation._z);
      model.position.set(modelPosition.x, modelPosition.y, modelPosition.z);

      model.castShadow = true;
      model.receiveShadow = true;
      modelsRef.current[pm.id] = model;
   
      scene.current.add(model);
    });

    setModelReady(true);
  };
const toggleModelsVisibility = (modelsIds) => {
//   console.log("toggleModelsVisibility", modelsRef.current);

  Object.keys(modelsRef.current).forEach((key) => {
    // console.log(key)
    // console.log(modelsRef.current[key]);
    const shouldBeVisible = modelsIds.includes(key);
    
    // Toggle model visibility
    modelsRef.current[key].visible = shouldBeVisible;
    
    // Toggle label visibility - handle the sprite properly
    if (modelsRef.current[key].label) {
      modelsRef.current[key].label.visible = shouldBeVisible;
    }
    
    // Also hide the circle
    // if (modelsRef.current[key].circle) {
    //   modelsRef.current[key].circle.visible = shouldBeVisible;
    // }
  });
  

};

const resetBuildingsTransform = () => {
  Object.keys(modelsRef.current).forEach((key) => {
    const model = modelsRef.current[key];
    const building = buildings.find((b) => b.id === key);
    if (building && building.default_view) {
      setupModelTransform(model, null, building);
    }
  });
};
  return {
    buildBuildingGroups,
    buildProjectModels,
    toggleModelsVisibility,
    resetBuildingsTransform,
    modelsRef,
    floorsNodes,
    floorLines,
    floorLabels,
  };
};
